import { EllipsisVertical} from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@comps/ui/popover";
import "@app/App.css";
import { Workspace } from "@dto/workspaces";
import WorkspaceMenuEditItem from "./WorkspaceMenuEditItem";
import { useState } from "react";
import { useModelStore } from "src/store";
import WorkspaceMenuDeleteItem from "./WorkspaceMenuDeleteItem";
import WorkspaceMenuExportItem from "./WorkspaceMenuExportItem";

interface WorkspaceActionButtonProps {
  workspace: Workspace;
  className: string;
}

function WorkspaceActionButton({ workspace, className }: WorkspaceActionButtonProps) {

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const workspaces = useModelStore((state) => state.workspaces);
  const setWorkspaces = useModelStore((state) => state.updateWorkspaces);
  const setSelectedWorkspace = useModelStore((state) => state.selectWorkspace);


  const deleteWorkspaceFromState = (workspace: Workspace) => {
    const newWorkspaces = workspaces.filter(w => w._key !== workspace._key);
    setWorkspaces(newWorkspaces);
    if (newWorkspaces.length > 0) {
      setSelectedWorkspace(newWorkspaces[0]);
    } else {
      setSelectedWorkspace(null);
    }
  }

  const deleteWorkspace = (workspace: Workspace) => {
    deleteWorkspaceFromState(workspace);
    setIsPopoverOpen(false);

  }

  const updateWorkspace = (workspace: Workspace) => {
    const newWorkspaces = workspaces.map((w: Workspace) => {
      if (w._key === workspace._key) {
        return workspace;
      }
      return w;
    });
    setWorkspaces(newWorkspaces);
    if (workspace?._key === workspace._key) {
      setSelectedWorkspace(workspace);
    }
  }

  const workspaceUpdated = (workspace: Workspace) => {
    updateWorkspace(workspace);
    setIsPopoverOpen(false);
  }

  const workspaceExported = (workspace: Workspace) => {
    setIsPopoverOpen(false);
  }

  const closeMenu = () => {
    setIsPopoverOpen(false);
  }


  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsPopoverOpen(true);
  }

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault(); 
    e.stopPropagation(); 
    setIsPopoverOpen(false);
  }

  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger className={className} onClick={handleClick}>
          <EllipsisVertical />
      </PopoverTrigger>
      <PopoverContent className="w-max p-1">
        <ul onClick={onClick}>
          <li ><WorkspaceMenuEditItem workspace={workspace} onWorkpaceUpdate={workspaceUpdated} closeMenu={closeMenu} /></li>
          <li ><WorkspaceMenuDeleteItem workspace={workspace} onWorkpaceDelete={deleteWorkspace} closeMenu={closeMenu} /></li>
          <li ><WorkspaceMenuExportItem workspace={workspace} onWorkpaceExport={workspaceExported} closeMenu={closeMenu} /></li>
        </ul>
      </PopoverContent>
    </Popover>
  )
}

export default WorkspaceActionButton;
